import { parseAsStringLiteral, useQueryState } from "nuqs";
import LogoutModal from "./logout.modal.component";

const authModals = ["logout"] as const;

export type AuthModal = (typeof authModals)[number];

export function useAuthModalsQueryState() {
	return useQueryState("modal", parseAsStringLiteral(authModals));
}

interface AuthModalsProps {
	openModal: AuthModal | null;
	setOpenModal: (modalToOpen: AuthModal | null) => void;
}

export function AuthModals({ openModal, setOpenModal }: AuthModalsProps) {
	return (
		<LogoutModal
			open={openModal === "logout"}
			onOpenChange={() => setOpenModal(null)}
		/>
	);
}
